import { ClearIndicatorProps, components } from "react-select";
import { IconClose } from "../../assets/svgs-index";

const ClearIndicator: React.FC<ClearIndicatorProps> = props => {
  return (
    <components.ClearIndicator {...props}>
      <img src={IconClose} alt='icon-close'></img>
    </components.ClearIndicator>
  );
};

export default ClearIndicator;